import { Layout as BaseLayout } from "antd"
import { FC, Suspense } from "react"
import { Outlet } from "react-router-dom"
import './Layout.less'
import { Header } from "./Header"
import FullScreenLoader from "src/components/ui/FullScreenLoader"

const Layout: FC = () => (
  <BaseLayout className={'enhance-and-share-layout'}>
    <BaseLayout.Header className={'header-wrapper'}>
      <Header />
    </BaseLayout.Header>
    <BaseLayout.Content className={'content-wrapper'}>
      <Suspense fallback={<FullScreenLoader />}>
        <Outlet />
      </Suspense>
    </BaseLayout.Content>
  </BaseLayout>
)

export { Layout }
